// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".padme {\n  padding: 0 15%;\n}\n#herocontent {\n  background: none;\n  height: 75%;\n  border: none;\n  box-shadow: none;\n}\n#herocontent > h2 {\n  font-family: \"Rubik\";\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 7% 25% 0%;\n  font-size: 1.5em;\n}", ""]);
// Exports
module.exports = exports;
